import { Component, Input } from "@angular/core";
import { PreviewItemComponent } from "../preview-item.component";

@Component({
    selector: "preview-item-context-special",
    imports: [],
    templateUrl: "./preview-item-context-menu-special.component.html"
})
export class PreviewItemContextMenuSpecial {
    @Input({ required: true }) previewItem!: PreviewItemComponent;

    public getCount(): number {
        return this.previewItem.previewItem.collected?.specialCount ?? 0;
    }

    public onIncrement(): void {
        this.previewItem.adjustCount(0, 1, 0);
    }

    public onDecrement(): void {
        this.previewItem.adjustCount(0, -1, 0);
    }

    public onChange(event: Event): void {
        var target = (event.target as HTMLInputElement);
        this.previewItem.setSpecialCount(Number.parseInt(target.value));
        target.value = `${this.getCount()}`;
    }
}